import { useEffect } from 'react';

/**
 * Scrolls a confirmation element into view when it becomes visible.
 *
 * Usage:
 * - Give your `ActionConfirmation` an `id`, e.g. `id="signup-confirmation"`.
 * - Call this hook inside the component:
 *   `useScrollToConfirmation(confirmation.visible, confirmation.message, 'signup-confirmation');`
 */
export const useScrollToConfirmation = (
  visible: boolean,
  message: string,
  elementId: string,
) => {
  useEffect(() => {
    if (!visible || !message) return;

    const scrollToConfirmation = () => {
      const el = document.getElementById(elementId);
      el?.scrollIntoView({ behavior: 'smooth', block: 'center' });
    };

    const rafId = requestAnimationFrame(() => {
      // Use a second frame so layout has settled
      requestAnimationFrame(scrollToConfirmation);
    });

    return () => cancelAnimationFrame(rafId);
  }, [visible, message, elementId]);
};

